export default "__VITE_ASSET__LY4RyKQ8__"